(function () {
  'use strict';
  const NS = 'http://www.w3.org/2000/svg';
  const node = (tag, attrs = {}) => { const el = document.createElementNS(NS, tag); Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k, v)); return el; };
  class BraceletStudio {
    constructor(root) {
      this.root = root;
      this.$ = s => root.querySelector(s);
      this.$$ = s => [...root.querySelectorAll(s)];
      this.materials = new Map(this.$$('[data-stone]').map(el => [el.dataset.stone, {
        id: el.dataset.stone, name: el.dataset.name, category: el.dataset.category,
        width: Number(el.dataset.width) || 10, height: Number(el.dataset.height) || 10,
        orient: el.dataset.orient, rotation: Number(el.dataset.rotation) || 0, art: el.querySelector('[data-art]'), button: el
      }]));
      this.key = `pyra-bracelet-studio-v1:${root.dataset.variant}`;
      this.state = { wrist: 160, beads: [] }; this.selected = -1; this.history = []; this.future = [];
      this.filter = 'all'; this.zoom = 1; this.busy = false; this.drag = null;
      this.minimum = Number(root.dataset.minimum) || 12; this.maximum = Number(root.dataset.maximum) || 60;
      this.storageOK = true;
      try {
        const saved = JSON.parse(localStorage.getItem(this.key));
        if (saved && [140,150,160,170,180].includes(saved.wrist) && Array.isArray(saved.beads)) {
          this.state = { wrist: saved.wrist, beads: saved.beads.filter(b => this.materials.has(b.id)).slice(0,this.maximum).map(b => ({id:b.id, turn: Number.isFinite(b.turn) ? b.turn % 360 : 0})) };
        }
      } catch (_) { this.storageOK = false; }
      this.$('[data-wrist]').value = String(this.state.wrist);
      this.bind(); this.render();
    }
    snapshot() { return JSON.parse(JSON.stringify(this.state)); }
    change(fn) {
      if (this.busy) return;
      this.history.push(this.snapshot()); if (this.history.length > 70) this.history.shift();
      this.future = []; fn(); this.render();
    }
    say(message) { this.$('[data-message]').textContent = message; }
    bind() {
      this.root.addEventListener('click', e => {
        const stone = e.target.closest('[data-stone]');
        if (stone) { this.add(stone.dataset.stone); return; }
        const filter = e.target.closest('[data-filter]');
        if (filter) { this.filter = filter.dataset.filter; this.filterMaterials(); return; }
        const action = e.target.closest('[data-action]');
        if (action) this.action(action.dataset.action);
      });
      this.$('[data-search]').addEventListener('input', () => this.filterMaterials());
      this.$('[data-wrist]').addEventListener('change', e => this.change(() => { this.state.wrist = Number(e.target.value); }));
      this.$('[data-add]').addEventListener('click', () => this.addToCart());
      this.$('[data-beads]').addEventListener('click', e => {
        if (this.suppressClick) { this.suppressClick = false; return; }
        const bead = e.target.closest('[data-bead-index]');
        if (bead) { this.selected = Number(bead.dataset.beadIndex); this.updateSelection(); }
      });
      this.$('[data-beads]').addEventListener('keydown', e => {
        const bead = e.target.closest('[data-bead-index]'); if (!bead || this.busy) return;
        const actions = {ArrowLeft:'earlier',ArrowRight:'later',Delete:'delete',Backspace:'delete'};
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.selected=Number(bead.dataset.beadIndex);this.updateSelection(); }
        if (actions[e.key]) { e.preventDefault(); this.selected=Number(bead.dataset.beadIndex);this.action(actions[e.key]);this.$(`[data-bead-index="${this.selected}"]`)?.focus(); }
      });
      const svg = this.$('[data-drawing]');
      svg.addEventListener('pointerdown', e => {
        const bead = e.target.closest('[data-bead-index]');
        if (!bead || this.busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
        this.selected = Number(bead.dataset.beadIndex); this.updateSelection();
        this.drag = { index:this.selected, x:e.clientX, y:e.clientY, target:this.selected, moved:false, pointer:e.pointerId };
        svg.setPointerCapture(e.pointerId);
      });
      svg.addEventListener('pointermove', e => {
        if (!this.drag || e.pointerId !== this.drag.pointer) return;
        if (Math.hypot(e.clientX-this.drag.x,e.clientY-this.drag.y)<7 && !this.drag.moved) return;
        this.drag.moved=true;
        const pt=svg.createSVGPoint();pt.x=e.clientX;pt.y=e.clientY;
        const matrix=this.$('[data-scene]').getScreenCTM();if (!matrix) return;
        const local=pt.matrixTransform(matrix.inverse());
        const angle=Math.atan2(local.y-300,local.x-300)*180/Math.PI;
        let distance=Infinity,target=this.drag.index;
        this.layout.positions.forEach((p,i)=>{const delta=Math.abs(((angle-p.angle+540)%360)-180);if(delta<distance){distance=delta;target=i;}});
        this.drag.target=target;
        this.$$('[data-bead-index]').forEach(el=>{el.style.opacity=Number(el.dataset.beadIndex)===target&&target!==this.drag.index?'.4':'1';});
        const el=this.$(`[data-bead-index="${this.drag.index}"]`);
        const p=this.layout.positions[this.drag.index];
        el?.setAttribute('transform',`translate(${local.x} ${local.y}) rotate(${p.rotation})`);
      });
      const finish=e=>{
        if(!this.drag || e.pointerId!==this.drag.pointer)return;
        const d=this.drag;this.drag=null;
        if(svg.hasPointerCapture(e.pointerId))svg.releasePointerCapture(e.pointerId);
        if(e.type==='pointercancel'){this.render();return;}
        if(d.moved){this.suppressClick=true;if(d.index!==d.target)this.change(()=>{const [bead]=this.state.beads.splice(d.index,1);this.state.beads.splice(d.target,0,bead);this.selected=d.target;});else this.render();}
      };
      svg.addEventListener('pointerup',finish);svg.addEventListener('pointercancel',finish);
    }
    add(id) {
      if(this.state.beads.length>=this.maximum){this.say(`This design can hold up to ${this.maximum} pieces. Remove a bead to add another.`);return;}
      this.change(()=>{const at=this.selected>=0?this.selected+1:this.state.beads.length;this.state.beads.splice(at,0,{id,turn:0});this.selected=at;});
    }
    action(action) {
      if(this.busy)return;
      const n=this.state.beads.length,i=this.selected;
      if(action==='undo'&&this.history.length){this.future.push(this.snapshot());this.state=this.history.pop();this.selected=-1;this.render();this.say('Last change undone.');return;}
      if(action==='redo'&&this.future.length){this.history.push(this.snapshot());this.state=this.future.pop();this.selected=-1;this.render();this.say('Change restored.');return;}
      if(action.startsWith('zoom')){this.zoom=action==='zoom-reset'?1:Math.max(.7,Math.min(1.3,this.zoom+(action==='zoom-in'?.1:-.1)));this.renderDrawing();return;}
      if(action==='clear'&&n){this.change(()=>{this.state.beads=[];this.selected=-1;});return;}
      if(action==='demo') {
        const design=['amethyst','rose_quartz','clear_quartz','gold_spacer','amazonite','amazonite','gold_spacer','clear_barrel','rose_quartz','amethyst','gold_spacer','freeform_black_gold','gold_spacer','amethyst','rose_quartz','clear_barrel','gold_spacer','amazonite','amazonite','gold_spacer','clear_quartz','rose_quartz','amethyst'];
        this.change(()=>{this.state.beads=design.filter(id=>this.materials.has(id)).slice(0,this.maximum).map(id=>({id,turn:0}));this.selected=-1;});return;
      }
      if(i<0||i>=n)return;
      if(action==='duplicate'&&n<this.maximum){this.change(()=>{this.state.beads.splice(i+1,0,{...this.state.beads[i]});this.selected=i+1;});return;}
      if(action==='delete'){this.change(()=>{this.state.beads.splice(i,1);this.selected=Math.min(i,this.state.beads.length-1);});return;}
      if(action==='rotate'){this.change(()=>{this.state.beads[i].turn=(this.state.beads[i].turn+15)%360;});return;}
      const to=action==='earlier'?i-1:action==='later'?i+1:i;
      if(to!==i&&to>=0&&to<n)this.change(()=>{[this.state.beads[i],this.state.beads[to]]=[this.state.beads[to],this.state.beads[i]];this.selected=to;});
    }
    filterMaterials() {
      const search=this.$('[data-search]').value.trim().toLowerCase();let visible=0;
      this.$$('[data-filter]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.filter===this.filter)));
      this.materials.forEach(m=>{
        const used=this.state.beads.some(b=>b.id===m.id);
        const show=(!search||m.name.toLowerCase().includes(search))&&(this.filter==='all'||(this.filter==='used'?used:m.category===this.filter));
        m.button.hidden=!show;if(show)visible++;
        const quantity=this.state.beads.filter(b=>b.id===m.id).length;
        const badge=m.button.querySelector('[data-quantity]');badge.hidden=!quantity;badge.textContent=quantity;
      });
      this.$('[data-search-empty]').hidden=visible>0;
    }
    renderDrawing() {
      const pieces=this.state.beads.map(b=>{const m=this.materials.get(b.id);return {...m,rotation:m.rotation+b.turn};});
      this.layout=window.PyraBraceletGeometry.arrange(pieces,this.state.wrist);
      const maxSize=Math.max(10,...pieces.map(m=>Math.hypot(m.width,m.height)));
      this.scale=235/(this.layout.radius+maxSize/2);
      const ring=this.$('[data-ring]');ring.setAttribute('r',this.layout.radius*this.scale);
      this.$('[data-scene]').setAttribute('transform',`translate(300 300) scale(${this.zoom}) translate(-300 -300)`);
      this.$('[data-zoom-label]').textContent=`${Math.round(this.zoom*100)}%`;
      this.$('[data-action="zoom-in"]').disabled=this.zoom>=1.29;
      this.$('[data-action="zoom-out"]').disabled=this.zoom<=.71;
      const container=this.$('[data-beads]');container.replaceChildren();
      this.layout.positions.forEach((p,index)=>{
        const m=pieces[index],w=p.width*this.scale,h=p.height*this.scale;
        const group=node('g',{'class':'pyra-studio__bead','data-bead-index':index,'role':'button','tabindex':'0','aria-label':`Bead ${index+1}: ${m.name}. Arrow keys move, Delete removes.`,transform:`translate(${300+p.x*this.scale} ${300+p.y*this.scale}) rotate(${p.rotation})`});
        group.append(node('rect',{x:-Math.max(24,w+8)/2,y:-Math.max(24,h+8)/2,width:Math.max(24,w+8),height:Math.max(24,h+8),rx:8,'class':'pyra-studio__hit'}));
        const art=m.art.cloneNode(true);art.setAttribute('x',-w/2);art.setAttribute('y',-h/2);art.setAttribute('width',w);art.setAttribute('height',h);art.classList.add('pyra-studio__bead-art');
        art.style.width=`${w}px`;art.style.height=`${h}px`;
        const clipId=`pyra-clip-${this.root.dataset.sectionId}-${index}`;
        const clip=node('clipPath',{id:clipId});clip.append(node('rect',{x:-w/2,y:-h/2,width:w,height:h}));
        const clipped=node('g',{'clip-path':`url(#${clipId})`});clipped.append(art);
        group.append(clip,clipped);container.append(group);
      });
      this.$('[data-empty]').hidden=pieces.length>0;
      this.updateSelection();
    }
    updateSelection() {
      this.$$('[data-bead-index]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.beadIndex)===this.selected)));
      const b=this.state.beads[this.selected];
      this.$('[data-selection]').textContent=b?`Bead ${this.selected+1} / ${this.state.beads.length} · ${this.materials.get(b.id).name}`:'Select a bead on the bracelet to edit it.';
      this.$$('[data-edit]').forEach(el=>{el.disabled=!b||this.busy;});
      this.$('[data-action="earlier"]').disabled=!b||this.selected===0||this.busy;
      this.$('[data-action="later"]').disabled=!b||this.selected===this.state.beads.length-1||this.busy;
      this.$('[data-action="duplicate"]').disabled=!b||this.state.beads.length>=this.maximum||this.busy;
    }
    render() {
      this.$('[data-wrist]').value=String(this.state.wrist);
      this.renderDrawing();this.filterMaterials();
      const n=this.state.beads.length;
      this.$('[data-count]').textContent=n;
      this.$('[data-run]').textContent=`${Math.round(this.layout.run*10)/10} mm`;
      this.$('[data-meter]').style.width=`${Math.round(this.layout.fill*100)}%`;
      this.$('[data-fit]').textContent=!n?'The beginning of something personal.':this.layout.overflow?'A fuller arrangement. Your maker will check the final fit.':this.layout.fill>=1?'Your stones complete the circle.':'Stones sit together along the cord. Add more to complete the circle.';
      this.$('[data-action="undo"]').disabled=!this.history.length;
      this.$('[data-action="redo"]').disabled=!this.future.length;
      this.$('[data-action="clear"]').disabled=!n;
      const list=this.$('[data-inuse]');list.replaceChildren();
      const counts=new Map();this.state.beads.forEach(b=>counts.set(b.id,(counts.get(b.id)||0)+1));
      counts.forEach((count,id)=>{const m=this.materials.get(id),row=document.createElement('div'),label=document.createElement('span'),qty=document.createElement('b');row.className='pyra-studio__inuse';label.textContent=m.name;qty.textContent=`× ${count}`;row.append(m.art.cloneNode(true),label,qty);list.append(row);});
      if(!n){const p=document.createElement('p');p.className='pyra-studio__small';p.textContent='Your chosen stones will appear here.';list.append(p);}
      this.$('[data-add]').disabled=this.busy||n<this.minimum||this.root.dataset.available!=='true'||this.root.dataset.checkout!=='true';
      if(this.root.dataset.checkout!=='true')this.say('Preview studio — materials are being finalised.');
      else if(this.root.dataset.available!=='true')this.say('This bracelet is currently unavailable. You can still save a design here.');
      else if(n<this.minimum)this.say(`Choose at least ${this.minimum} pieces to add your design to cart.`);
      else this.say('Your arrangement will be saved with your order.');
      try {localStorage.setItem(this.key,JSON.stringify(this.state));}catch(_){this.storageOK=false;}
      this.$('[data-saved]').textContent=this.storageOK?'Saved on this device':'Autosave unavailable';
    }
    async addToCart() {
      if(this.busy||this.$('[data-add]').disabled)return;
      this.busy=true;this.$('[data-add]').disabled=true;this.$('[data-add]').textContent='Adding your design…';this.updateSelection();
      const root=window.Shopify?.routes?.root||'/';
      const properties={
        'DIY bracelet design':this.state.beads.map((b,i)=>`${i+1}. ${this.materials.get(b.id).name}`).join(' · '),
        'Wrist size':`${this.state.wrist/10} cm`,'DIY cord':'Clear elastic cord',
        '_DIY studio':'Pyracrystal v1','_DIY arrangement':JSON.stringify({wrist:this.state.wrist,beads:this.state.beads.map(b=>{const m=this.materials.get(b.id);return {id:b.id,name:m.name,width:m.width,height:m.height,orientation:m.orient,rotation:m.rotation+b.turn};})})
      };
      try {
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.root.dataset.variant,quantity:1,properties}]})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Your design could not be added. Please try again.');
        // Navigate only after Shopify has accepted the exact arrangement.
        window.location.assign(`${root}cart`);
      } catch(error) {
        this.busy=false;this.render();this.$('[data-add]').textContent='Add your design to cart';this.say(error.message||'Connection lost. Please try again.');
      }
    }
  }
  function mount(scope=document){scope.querySelectorAll('[data-pyra-studio]').forEach(el=>{if(!el.dataset.mounted){el.dataset.mounted='true';new BraceletStudio(el);}});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
